import { Component } from 'react';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import messages from './UploadButton.messages';
import styles from './UploadButton.module.css';
import { UploadSVG } from '../../../svgComponents/uploadSVG';

class UploadButton extends Component {
    getUploadClassName() {
        const { className, pending } = this.props;

        if (pending) {
            return classNames(className, styles.uploadPending);
        }

        return classNames(className, styles.upload);
    }

    handleClick = () => {
        const { onClick, pending } = this.props;

        if (!pending && onClick) {
            onClick();
        }
    };

    render() {
        const { children } = this.props;

        return (
            <button
                className={this.getUploadClassName()}
                onClick={this.handleClick}
            >
                <UploadSVG className={styles.uploadIcon} />
                {children ? (
                    children
                ) : (
                    <FormattedMessage {...messages.upload} />
                )}
            </button>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default UploadButton;
